import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const ProgressWeldBoxStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  mb: { sm: '500' },
})`
  ${({ theme }) => css`
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
    background-color: ${theme.colors.grey[100]};
    border-radius: ${theme.spacings[400]};
  `}
`;
